document.addEventListener('change', function (event) {
  var select = event.target.closest('.card__variant-select');
  if (!select) return;

  var option = select.selectedOptions[0];
  if (!option) return;

  var form = select.closest('product-form');
  if (!form) return;

  var idInput = form.querySelector('[data-variant-id-input]');
  if (idInput) idInput.value = option.value;

  var cardContent = select.closest('.card__content');
  var priceNode = cardContent ? cardContent.querySelector('.price-item--regular') : null;
  if (priceNode && option.dataset.price) {
    priceNode.textContent = option.dataset.price;
  }

  var submitButton = form.querySelector('[type="submit"]');
  if (!submitButton) return;

  submitButton.disabled = option.disabled;

  var label = submitButton.querySelector('span');
  var soldOutMessage = submitButton.querySelector('.sold-out-message');
  if (label && soldOutMessage) {
    label.classList.toggle('hidden', option.disabled);
    soldOutMessage.classList.toggle('hidden', !option.disabled);
  }
});
